<template>
<div>

    <nav class="navbar has-shadow" :transparent='true' role="navigation" aria-label="main navigation">
        <div class="container">

            <div class="navbar-brand">
                <router-link class="navbar-item itm" to="/dm/dashboard">
                    <img src="/static/lu_logo.png" alt="LetsUpgrade">
                   <!--  &ensp; <img src="/static/logo 2.png" alt="ISA"> -->
                    <!-- &ensp; LetsUpgarde Online Learning -->
                </router-link>
                
            </div>
           
        </div>
    </nav>
<div class="news">
              <marquee class="news-content"> <strong style="color:white">Your Saftey is our concern, hence until 31th March as suggested by Govt. we will engange with you online</strong> </marquee>
            </div>
    <div class="section ">
        
        <div class="container">
            
            <router-view />
        </div>
    </div>
</div>
</template>

<script>
import Firebase from '../../lib/Firebase';
/* import Firestore from "../../lib/Firestore"; */
export default {
    name: 'navbar',
    created() {
        var vm = this
        Firebase.auth().onAuthStateChanged(function (user) {

            if (user) {
                vm.uid = user.uid
                let obj = {
                    state: 'online',
                }
                Firebase.firestore().collection('users').doc(user.uid).update(obj);
                let docRef = Firebase.firestore().collection("users").doc(user.uid);
                docRef.get().then(doc => {
                    vm.user = doc.data()
                    // console.log(vm.user)
                })
            } else {
                // No user is signed in.
            }
        });
    },
    data() {
        return {
            showNav: false,
            unreads: null,
            uid: null,
            user: {
                name: ''
            }
        }
    },
    computed: {
        showAnalytics() {
            return this.$route.path === '/dm/analytics';
        }
    },

    methods: {

        logout() {
            let obj = {
                state: 'offline',
            }
            Firebase.firestore().collection('users').doc(this.uid).update(obj);

            Firebase.auth().signOut().then(function () {
                // Sign-out successful.

                //console.log("SignOut SuccessFul")
                this.$router.push('/');

            }).catch(function (error) {
                // An error happened.
            });

        },

        toggleNav() {
            this.isNavOpen = !this.isNavOpen;
        }
    }
};
</script>

<style>
.main-container {
    margin-top: 2rem !important;
}

/* .logo-img{

  display: flex;
  flex-direction: column;
} */
/* .itm {
    font-family: 'Lora', serif;
}
 */
/* .itm2 .navbar-item {
    font-family: "Roboto", sans-serif;
} */

.navbar {
    background-color: rgb(255, 255, 255);
}

@media screen and (max-width: 700px) {
    .sidenav {
        width: 100%;
        height: auto;
        position: relative;
    }

    .sidenav a {
        float: left;
    }

    div.content {
        margin-left: 0;
    }
}

@media screen and (max-width: 400px) {
    .sidenav a {
        text-align: center;
        float: none;
    }
}

.sidenav a:hover {
    color: #f1f1f1;
}

.main {
    margin-left: 160px;
    /* Same as the width of the sidenav */
    font-size: 28px;
    /* Increased text to enable scrolling */
    padding: 0px 10px;
}

@media screen and (max-height: 450px) {
    .sidenav {
        padding-top: 15px;
    }

    .sidenav a {
        font-size: 18px;
    }
}
.news{
  background: linear-gradient(234deg, #ffc107, #ff4400);
background-size: 100% 100%;
 height: 30pt;
-webkit-animation: AnimationName 3s ease infinite;
-moz-animation: AnimationName 3s ease infinite;
animation: AnimationName 3s ease infinite;

@-webkit-keyframes AnimationName {
    0%{background-position:0% 91%}
    50%{background-position:100% 10%}
    100%{background-position:0% 91%}
}
@-moz-keyframes AnimationName {
    0%{background-position:0% 91%}
    50%{background-position:100% 10%}
    100%{background-position:0% 91%}
}
@keyframes AnimationName {
    0%{background-position:0% 91%}
    50%{background-position:100% 10%}
    100%{background-position:0% 91%}
}
   
}
.news-content{
 margin-top: 5pt;
    vertical-align: middle;
    color :white;
    font-weight: 1000;
}
</style>



// WEBPACK FOOTER //
// src/pages/dashboard/Navbar.vue